import React from 'react';
import { Navigate } from 'react-router-dom';

// Profile
import UserProfile from '../pages/Authentication/user-profile';

// Authentication related pages
import Login from '../pages/Authentication/Login';
import Logout from '../pages/Authentication/Logout';
import Register from '../pages/Authentication/Register';
import ForgetPwd from '../pages/Authentication/ForgetPassword';

// Dashboard
import Dashboard from '../pages/Dashboard/index';
import BookingDetails from 'pages/BookingDetails';
import Bookings from 'pages/Bookings';
import AllQuote from 'pages/Quotations/AllQuote';
import ContractRates from 'pages/Quotations/ContractRates';

const authProtectedRoutes = [
	{ path: '/dashboard', component: <Dashboard /> },
	// //profile
	{ path: '/profile', component: <UserProfile /> },
	{ path: '/bookings', component: <Bookings /> },
	{ path: '/booking-details/:bookingId', component: <BookingDetails /> },
	{ path: '/all-quotations', component: <AllQuote /> },
	{ path: '/contract-rates', component: <ContractRates /> },
	// this route should be at the end of all other routes
	// eslint-disable-next-line react/display-name
	{
		path: '/',
		exact: true,
		component: <Navigate to="/dashboard" />
	}
];

const publicRoutes = [
	{ path: '/login', component: <Login /> },
	{ path: '/logout', component: <Logout /> },
	{ path: '/forgot-password', component: <ForgetPwd /> },
	{ path: '/register', component: <Register /> }
];

export { authProtectedRoutes, publicRoutes };
